import { ContractCondition } from '~/typings/entities/ContractCondition';

export const CONDITION_EVENT_LABELS: Record<string, string> = {
  NEW: 'Contratação',
  RENEGOTIATION: 'Renegociação',
  REFIN: 'Refinanciamento',
};

export const conditionLabel = (condition: ContractCondition): string => {
  const event = (condition.event ? CONDITION_EVENT_LABELS[condition.event] : undefined) || condition.event || '';
  return `v${condition.version} · ${event} · CCB ${condition.ccb}`;
};

const VERSIONED_FIELDS: Record<string, (c: ContractCondition) => unknown> = {
  status: (c) => c.details?.status,
  situationStatus: (c) => c.details?.situationStatus,
  ccb: (c) => c.ccb,
  netValue: (c) => c.details?.netValue,
  grossValue: (c) => c.details?.grossValue,
  total: (c) => c.details?.total,
  installments: (c) => `${c.details?.numberInstallments}x${c.details?.installments?.[0]?.amount}`,
  contractDate: (c) => c.details?.contractDate,
  paymentDate: (c) => c.details?.paymentDate,
  monthlyRate: (c) => c.details?.monthlyRate,
  annualRate: (c) => c.details?.annualRate,
  monthlyCet: (c) => c.details?.monthlyCet,
  annualCet: (c) => c.details?.annualCet,
  totalIof: (c) => c.details?.totalIof,
  additionalIof: (c) => c.details?.additionalIof,
  employerCnpj: (c) => c.details?.employer?.cnpj,
  employerCnae: (c) => c.details?.employer?.cnae,
  fundingName: (c) => c.details?.fundingName,
};

export const computeChangedFields = (selected?: ContractCondition, previous?: ContractCondition): string[] => {
  if (!selected || !previous) return [];
  return Object.keys(VERSIONED_FIELDS).filter(
    (key) => VERSIONED_FIELDS[key](selected) !== VERSIONED_FIELDS[key](previous),
  );
};

export const buildResumeOverride = (condition: ContractCondition) => {
  const d = condition.details;
  return {
    financialInstitutionKey: condition.ccb,
    netValue: d?.netValue,
    netValueApproved: d?.netValue,
    grossValue: d?.grossValue,
    numberOfInstallments: d?.numberInstallments,
    installmentValue: d?.installments?.[0]?.amount,
    installmentValueApproved: d?.installments?.[0]?.amount,
    nominalRatePerMonth: d?.monthlyRate,
    nominalRatePerYear: d?.annualRate,
    totalEffectiveCostPerMonth: d?.monthlyCet,
    totalEffectiveCostPerYear: d?.annualCet,
    iof: d?.totalIof,
    contractDate: d?.contractDate,
    contractInitialDate: d?.contractDate,
    ...(d?.paymentDate ? { paymentDate: d.paymentDate } : {}),
    turingContractDetailsResponseDTO: {
      fundingName: d?.fundingName,
      employer: d?.employer,
      status: d?.status,
      situationStatus: d?.situationStatus,
      outstandingBalance: condition.current ? d?.outstandingBalance : null,
      additionalIof: d?.additionalIof,
      monthlyCet: d?.monthlyCet,
      annualCet: d?.annualCet,
      annualRate: d?.annualRate,
      total: d?.total,
    },
  };
};
